fragment ContentBlockForm on contentBlocks_form_BlockType {
    title: sectionTitle
    formUrl

    anchorId
    anchorLabel
}
